import { Component, inject, input } from '@angular/core';
import {
  RdsBadgeModule,
  RdsButtonModule,
  RdsCardModule,
  RdsIconsModule,
} from '@rds/angular-components';
import { Router } from '@angular/router';
import { Components } from '../../../components';
import { DynamicModule } from 'ng-dynamic-component';
import { MatTooltipModule } from '@angular/material/tooltip';
@Component({
  selector: 'inexp-offering-card',
  imports: [
    RdsButtonModule,
    RdsIconsModule,
    RdsCardModule,
    DynamicModule,
    RdsBadgeModule,
    MatTooltipModule,
  ],
  templateUrl: './sb-offering-card.component.html',
  styleUrl: './sb-offering-card.component.scss',
})
export class SbOfferingCardComponent {
  router = inject(Router);

  _uid = input<string>();
  displayName = input<string>();
  badges = input<any[]>();
  description = input<string>();
  offeringImage = input<string>();
  buttons = input<any[]>([]);
  categories = input<any[]>();
  classificationLevel = input<string>();
  status = input<string>();
  type = input<string[]>();

  cardSelected: boolean = false;
  components = Components;
}
